var _path, _path2, _path3, _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 96,
    viewBox: "0 0 97 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.3572 74.7425C31.3572 73.9851 31.9712 73.3711 32.7286 73.3711H64.2715C65.0289 73.3711 65.6429 73.9851 65.6429 74.7425V76.114H31.3572V74.7425Z",
    fill: "#959BA4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1269 67.8848H41.4126C41.4126 69.8352 41.0055 71.6906 40.2715 73.3705H56.2681C55.5341 71.6906 55.1269 69.8352 55.1269 67.8848Z",
    fill: "#646B76"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4714 25.3705C11.4714 22.3408 13.9275 19.8848 16.9571 19.8848H80.0429C83.0725 19.8848 85.5286 22.3408 85.5286 25.3705V63.7705C85.5286 66.8002 83.0725 69.2562 80.0429 69.2562H16.9572C13.9275 69.2562 11.4714 66.8002 11.4714 63.7705V25.3705Z",
    fill: "#F5F6F9"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 58.7856,
    y: 33.5996,
    width: 4.11429,
    height: 21.9429,
    fill: "#646B76"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 46.4429,
    y: 39.0859,
    width: 4.11429,
    height: 16.4571,
    fill: "#959BA4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 34.1001,
    y: 44.5723,
    width: 4.11429,
    height: 10.9714,
    fill: "#959BA4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.1c2ac2f9.svg";
export { ForwardRef as ReactComponent };